module.exports = __webpack_public_path__ + "img/bg16.3e18b4cc.jpg";